import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const CompanyLpnSettingSchema = withDefaults({
  type: 'company-lpn-setting',
  objectExtensions: ['company-lpn-setting'],
  fields: [
    {
      kind: 'attribute',
      name: 'isEnabled',
    },
    {
      kind: 'attribute',
      name: 'employerRecommended',
    },
    {
      kind: 'attribute',
      name: 'cappedTuition',
    },
    {
      kind: 'attribute',
      name: 'hasDiscount',
    },
    {
      kind: 'attribute',
      name: 'discountPercent',
    },
    {
      kind: 'attribute',
      name: 'description',
    },
    {
      kind: 'attribute',
      name: 'url',
    },
    {
      kind: 'attribute',
      name: 'badgeCappedTuition',
    },
    {
      kind: 'attribute',
      name: 'badgeDiscount',
    },
    {
      kind: 'attribute',
      name: 'badgeFamilySavings',
    },
    {
      kind: 'attribute',
      name: 'badgeFeesWaived',
    },
    {
      kind: 'attribute',
      name: 'providedBy',
    },
    {
      kind: 'attribute',
      name: 'badgeCappedTuitionRange',
    },
    {
      kind: 'attribute',
      name: 'discountPercentRange',
    },
    {
      kind: 'attribute',
      name: 'saveDollarAmountRange',
    },
    {
      kind: 'attribute',
      name: 'saveDollarAmountValue',
    },
    {
      kind: 'attribute',
      name: 'saveDollarAmount',
    },
    {
      kind: 'attribute',
      name: 'partTuitionWaiver',
    },
    {
      kind: 'attribute',
      name: 'lowTuition',
    },
    {
      kind: 'attribute',
      name: 'costPerCredit',
    },
    {
      kind: 'attribute',
      name: 'costPerCreditRange',
    },
    {
      kind: 'attribute',
      name: 'format',
    },
    {
      kind: 'attribute',
      name: 'programs',
    },
    {
      kind: 'attribute',
      name: 'areasOfStudy',
    },
    {
      kind: 'attribute',
      name: 'imageUrl',
    },
    {
      kind: 'attribute',
      name: 'useDiscountPercentRange',
    },
    {
      kind: 'attribute',
      name: 'useSaveDollarAmountRange',
    },
    {
      kind: 'attribute',
      name: 'useCostPerCreditRange',
    },
    {
      kind: 'belongsTo',
      name: 'companySetting',
      type: 'company-setting',
      options: {
        async: false,
        inverse: 'companyLpnSetting',
      },
    },
    {
      kind: 'belongsTo',
      name: 'lpnPage',
      type: 'lpn-page',
      options: {
        async: false,
        inverse: 'companyLpnSettings',
      },
    },
  ],
});

export default CompanyLpnSettingSchema;
